import { http } from '@/lib/http';
import type { APIResponse } from '@/types';
import type { GfMaterialDetail } from '../types';

type GetMaterialDetailResponse = APIResponse<GfMaterialDetail>;

export const getMaterialDetail = async (id: number): Promise<GetMaterialDetailResponse> => {
  return await http<GetMaterialDetailResponse>(`/user/v1/gf/materials/${id}`, {
    method: 'GET',
  });
};
